import React from 'react';
import { observer } from 'mobx-react-lite';

import './style.sass';
import { BackButton } from '../../BackButton';
import { useModelWithArguments } from 'app/hooks/useViewModel';
import { Routes } from 'src/types/routes';
import { CampaignViewModel } from 'app/viewModels/components/CampaignViewModel';

type Props = {
    campaignId: string,
};

export const CampaignInnerBreadCrumbs = observer(({ campaignId }: Props) => {
    const { orderNumber } = useModelWithArguments(CampaignViewModel, campaignId);

    const title = orderNumber ? `#${orderNumber}` : '#';
    return (
        <div className="user-inner-brea-crumbs">
            <BackButton to={Routes.Dashboard.Campaigns}/>

            <h2 className="title-h2">{title}</h2>
        </div>
    );
});
